<template>
  <div
    class="flex rounded-lg border-2 border-red-300 bg-red-100 p-5 text-red-600 dark:border-red-400 dark:bg-slate-800 dark:text-red-400"
    role="alert"
  >
    <ExclamationTriangleIcon
      class="mr-3 inline h-6 w-6 flex-shrink-0"
      aria-hidden="true"
    />
    <I18n path="core.widget_not_found" />
  </div>
</template>

<script lang="ts" setup>
import { ExclamationTriangleIcon } from "@heroicons/vue/24/outline";
import { useI18n } from "@src/composables/i18n";
const { I18n } = useI18n({ packs: ["core"] });
</script>
